module.exports = __webpack_public_path__ + "img/HN.515bf7aa.svg";